import Leaderboards from './leaderboards'
import "./style.scss"
import imgLogo from '../assets/block-friday-logo2.png'
import useLocalStorage from "use-local-storage"
import EmailPopup from './email-popup'
import { useEffect, useState } from 'react'
import { getLeaderBoard, getPlayerGames, getStats } from '../utils/api'
import { max, min } from 'lodash'
import { sha256 } from 'js-sha256'
import SocialShare from './social-share'

const GameWindow = props => {
    const [ email, setEmail ] = useLocalStorage( 'email', '' )
    const [ nick, setNick ] = useLocalStorage( 'nick', '' )
    const [ includeNewsletter, setIncludeNewsletter ] = useLocalStorage( 'includeNewsletter', false )

    const [ doFetch, setDoFetch ] = useState( 0 )
    const [ scores, setScores ] = useState( [] )
    const [ stats, setStats ] = useState( [] )
    const [ playerStats, setPlayerStats ] = useState( {
        games: '-',
        bestScore: '-',
        tickets: '-',
        numGames: '-',
        justBeatHighScore: false,
    } )

    const showEmailPopup = ! email || ! nick

    useEffect( () => {
        const fetch = async () => {
            setScores( await getLeaderBoard( props.game ) )
            setStats( await getStats() )
            const playerGames = await getPlayerGames( email, props.game )
            const bestScore = props.bestScoreFunc( playerGames, props.game )
            setPlayerStats( {
                games: playerGames,
                bestScore,
                tickets: props.ticketNumFunc( bestScore ),
                numGames: playerGames?.length || 0,
                justBeatHighScore: false,
            } )
        }
        fetch()
        const t = setTimeout( () => setDoFetch( v => v + 1 ), 60 * 3000 )
        return () => clearTimeout( t )
    }, [ props.game, email, doFetch, props.bestScoreFunc, props.ticketNumFunc ] ) // eslint-disable-line

    const onGameOver = ( score ) => {
        setScores( scores => {
            const newScores = [
                ...scores, {
                    id: (new Date()).toISOString(),
                    email_hash: sha256(email),
                    alias: nick,
                    game_type: props.game,
                    score,
                }
            ].sort( ( a, b ) => props.game === 'MEMORY_BLOCK' ? a.score - b.score : b.score - a.score)
            return newScores
        })
        setPlayerStats( playerStats => {
            const games = playerStats.games
            if ( games.push ) {
                games.push( { score } )
                const bestScore = props.bestScoreFunc( games, props.game )

                return {
                    games,
                    bestScore,
                    tickets: props.ticketNumFunc( bestScore ),
                    numGames: playerStats.numGames + 1,
                    justBeatHighScore: props.game === 'MEMORY_BLOCK' ? bestScore < playerStats.bestScore : bestScore > playerStats.bestScore,
                }
            }
        } )
    }

    return (
        <>
            <a href="https://wpstackable.com/bfcm-2023/" target="_stackable" className="game-window__logo"><img className="" src={ imgLogo } alt="Block Friday Logo" /></a>
            { showEmailPopup && (
                <EmailPopup 
                    email={ email } 
                    nick={ nick } 
                    includeNewsletter={ includeNewsletter }
                    onChange={ ( email, nick, includeNewsletter) => {
                        setEmail( email )
                        setNick( nick )
                        setIncludeNewsletter( includeNewsletter )
                    } } 
                />
            ) }
            { ! showEmailPopup && (
                <div className="game-window__content">
                    <div className="game-window__info">
                        { props.renderInfo( { email, nick, setEmail, setNick, ...playerStats } ) }
                    </div>
                    { props.renderGame( { email, nick, includeNewsletter, onGameOver, scores, rankCheckFunc: props.rankCheckFunc, playerStats, stats } ) }
                    { props.children }
                    <Leaderboards game={ props.game } scores={ scores } stats={ stats } email={ email } />
                </div>
            ) }
            <div className="bottom-social">
                <SocialShare game={ props.game } score={ ! playerStats || playerStats.bestScore === '-' ? null : playerStats.bestScore } label="Plz share" />
            </div>
        </>
    )
}

const getBestScore = (games, gameType) => {
    const minMaxFn = gameType === 'MEMORY_BLOCK' ? min : max
    return minMaxFn( games.map( game => game.score ) ) || 0
}

const rankCheckFunc = ( scores, score ) => {
    const scoresSorted = scores.map( game => game.score ).sort( ( a, b ) => b - a )
    const nearScore = scoresSorted.find( s => score >= s )
    const maxRank = scores.length < 500 ? scores.length : 501
    return nearScore ? scoresSorted.indexOf( nearScore ) + 1 : maxRank
}

const noop = () => {}

GameWindow.defaultProps = {
    game: 'FLAPPY_BLOCK',
    info: null,
    bestScoreFunc: getBestScore,
    ticketNumFunc: noop,
    rankCheckFunc,
}

export default GameWindow